import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

const CurrentLocationIcon: React.FC<SvgIconProps> = props => {
  return (
    <svg
      width="40"
      height="40"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
    >
      <circle cx="50" cy="50" r="25" fill="#0371B4" />
      <circle
        cx="50"
        cy="50"
        r="28"
        fill="none"
        stroke="white"
        strokeWidth="8"
      />
      <circle
        cx="50"
        cy="50"
        r="35"
        fill="none"
        stroke="#A2C3D7"
        strokeWidth="18"
        opacity="0.5"
      />
    </svg>
  );
};

export default CurrentLocationIcon;
